{
  "main": "Principal",
  "my_library": "Minha biblioteca",
  "node_names": {
    "Folder": "Pasta",
    "PersonalMappingLibrary": "Meu espaço de trabalho",
    "MappingLibrary": "Espaço de trabalho da equipe",
    "Map": "Plano",
    "Layer": "Camada",
    "MapObject": "Objeto",
    "Schedule": "Cronograma",
    "ScheduleVersion": "Cronograma"
  },
  "static_library_names": {
    "recently_viewed": "Visto recentemente",
    "favourites": "Favoritos"
  },
  "static_library_empty": {
    "recently_viewed": "Os planos que você abriu recentemente serão exibidos aqui",
    "favourites": "Os planos e pastas que você preferir serão exibidos aqui para que você possa acessá-los facilmente"
  },
  "static_library_empty_button": {
    "recently_viewed": "Comece com seu primeiro plano",
    "favourites": "Navegue pelos planos do projeto"
  },
  "node_content": {
    "last_activity": "Atividade mais recente {{ latestActivityDate }}",
    "created": "Criado em {{ createdAt }}",
    "last_viewed": "Última visualização {{ viewedAt }}"
  },
  "create_node": {
    "saveInFolder": "Salvar na pasta",
    "title": "Crie {{ nodeName }}",
    "fieldLabel": "{{ nodeName }} nome",
    "creating": "Criando {{ nodeName }}",
    "maxInputChars": "O nome não deve ter mais de 500 caracteres"
  },
  "permissions": "Editar {{ nodeName }} Permissões",
  "update_node": {
    "title": "Renomear {{ nodeName }}",
    "description": "Esse {{ nodeName }} será atualizado para todos.",
    "updating": "Renomeando {{ nodeName }}"
  },
  "delete_node": {
    "singular_title": "Excluir um {{ nodeType }}",
    "singular_description": "Excluir esse {{ nodeType }} também excluirá todo o conteúdo.",
    "singular_confirm_button": "Excluir {{ nodeType }}",
    "multi_title": "Excluir {{ count }} itens",
    "multi_description": "A exclusão desses itens também excluirá todo o conteúdo.",
    "multi_confirm_button": "Excluir itens"
  },
  "overflow": {
    "description": "Clique para abrir as opções para {{ nodeName }}",
    "rename": "Renomear {{ nodeName }}",
    "delete": "Excluir {{ nodeName }}",
    "permissions": "Alterar {{ nodeName }} Permissões"
  },
  "empty_node": "{{ nodeName }} está vazio",
  "folder_browser_view": {
    "while_in": {
      "list": "Exibir como blocos",
      "tile": "Exibir como lista"
    }
  },
  "sort": {
    "folder_first_asc": "Primeira pasta (A-Z)",
    "name_asc": "Nome (A-Z)"
  },
  "saveLocation": {
    "visibleYou": "Visível somente para você",
    "visibleOtherTeamMembers": "Visível para outros membros da equipe",
    "visibleWholeProject": "Visível para todos",
    "teamMembers": "membros da equipe"
  },
  "hints": {
    "PersonalMappingLibrary": {
      "title": "Meu espaço de trabalho",
      "first_paragraph": "Os planos que você criar aqui só estarão disponíveis para você. \nUse o botão “Criar um plano” para criar seu primeiro plano.",
      "second_paragraph": "Quando estiver pronto para compartilhar planos com sua equipe, você poderá usar o “Espaço de trabalho da equipe”."
    },
    "MappingLibrary": {
      "title": "Espaço de trabalho da equipe",
      "first_paragraph": "Os planos criados aqui são compartilhados com toda a sua equipe. Use esse espaço ao colaborar com outros membros da equipe.",
      "second_paragraph": "Você também pode organizar seus planos em pastas, como para diferentes departamentos."
    },
    "Map": {
      "title": "Nenhuma camada adicionada ainda",
      "first_paragraph": "Comece criando uma camada para adicionar objetos ao seu plano."
    },
    "Folder": {
      "title": "A pasta está vazia",
      "first_paragraph": "Use o botão “Criar um plano” acima para adicionar um plano aqui."
    },
    "ScheduleVersion": {
      "title": "{{ type }}",
      "first_paragraph": "Crie um {{ type }} para começar a agendar eventos."
    }
  },
  "hints_static_libraries": {
    "recently_viewed": {
      "title": "Visto recentemente",
      "first_paragraph": "Seus planos visualizados recentemente aparecerão aqui."
    },
    "favourites": {
      "title": "Favoritos",
      "first_paragraph": "Seus planos e pastas favoritos aparecerão aqui."
    }
  },
  "remove_node": {
    "singular_title": "Remover um {{ nodeType }}",
    "singular_description": "Remover esse {{ nodeType }} o removerá do plano, mas ainda existirá no plano original",
    "singular_confirm_button": "Remover {{ nodeType }}",
    "multi_title": "Excluir {{ count }} itens",
    "multi_description": "A exclusão desses itens também excluirá todo o conteúdo.\n \nAs camadas importadas/vinculadas serão removidas do plano, mas ainda existirão no plano original.",
    "multi_confirm_button": "Excluir itens"
  },
  "cannot_drop_folder_into_its_sub_folder": "Não é possível colocar uma pasta em sua própria subpasta",
  "drag_and_drop": {
    "moving_multiple_items": "Movendo {{ count }} itens..."
  },
  "create_map_location": "Salvar na pasta"
}